import React, { useState } from "react";
import AiPanel from "./AiPanel";

export function AppAiPanelExample() {
    const [open, setOpen] = useState(false);
    return (
        <>
            <button onClick={() => setOpen(true)}>Yapay Zeka Asistanı</button>
            <AiPanel isOpen={open} onClose={() => setOpen(false)} />
        </>
    );
}